// @ts-nocheck
/**
 * This file supports future marketplace safety features. Transaction-related enforcement is intentionally
 * hidden during Phase 1.
 */

import React from "react";
import LegalPageLayout, { BulletList, Section } from "../components/LegalPageLayout";
import "../styles/SafetyCenter.css";

export default function SafetyCenter() {
  return (
    <LegalPageLayout
      title="🛡️ Trust & Safety Center"
      subtitle="Learn how Cardex keeps our trading community safe"
      updated="February 7, 2026"
    >
      <Section title="Phase 1 Notice">
        <p style={{ 
          background: "linear-gradient(135deg, rgba(124, 243, 255, 0.1), rgba(111, 66, 193, 0.1))",
          padding: "14px 18px",
          borderRadius: "10px",
          border: "1px solid rgba(124, 243, 255, 0.25)",
          color: "rgba(124, 243, 255, 0.95)",
          fontWeight: "500"
        }}>
          This Trust & Safety Center reflects Cardex Phase 1 functionality. Cardex facilitates local, 
          in-person trading coordination only and does not process payments, shipping, or online transactions.
        </p>
      </Section>

      <Section title="Overview">
        <BulletList
          items={[
            "Cardex is a local, in-person trading platform",
            "No shipping or payments occur on the platform",
            "All trades are conducted face-to-face"
          ]}
        />
      </Section>

      <Section title="18+ Safety Enforcement">
        <BulletList
          items={[
            "Platform restricted to users 18+",
            "Age confirmation required at signup",
            "No minors permitted to meet adults"
          ]}
        />
      </Section>

      <Section title="Messaging Safety">
        <BulletList
          items={[
            "Profanity and slur filtering",
            "Warning not to share personal information",
            "In-app reporting available per message"
          ]}
        />
      </Section>

      <Section title="3-Strike Trust System">
        <div className="strike-cards">
          <div className="strike-card strike-1">
            <div className="strike-number">1️⃣</div>
            <h3>Warning</h3>
            <p>Account flagged. User receives notification and warning on profile.</p>
          </div>
          
          <div className="strike-card strike-2">
            <div className="strike-number">2️⃣</div>
            <h3>Temporary Suspension</h3>
            <p>Account temporarily suspended from platform access.</p>
          </div>
          
          <div className="strike-card strike-3">
            <div className="strike-number">3️⃣</div>
            <h3>Permanent Ban</h3>
            <p>Account permanently banned. No appeal. Cannot create new accounts.</p>
          </div>
        </div>
        <p style={{ 
          marginTop: "1.5rem", 
          color: "rgba(255, 255, 255, 0.65)",
          fontSize: "13px",
          fontStyle: "italic"
        }}>
          *Applies to behavior occurring within messaging, profiles, listings, and in-person trade coordination.
        </p>
      </Section>

      <Section title="Reporting & Moderation">
        <BulletList
          items={[
            "Users can report profiles and messages",
            "Moderation team reviews reports",
            "Repeat offenders are removed"
          ]}
        />
      </Section>

      <Section title="Counterfeit Prevention">
        <BulletList
          items={[
            "No counterfeit listings allowed",
            "Community reporting",
            "Zero-tolerance enforcement"
          ]}
        />
      </Section>

      <p className="legal-footer-text">
        Our safety measures are designed to protect the Cardex trading community.
      </p>
    </LegalPageLayout>
  );
}
